/* eslint-disable react/no-unescaped-entities */

import Head from 'next/head';

import TemplatePoliticaPrivacidade from '@/components/Legal/Privacidade';

export default function PoliticaDePrivacidade() {
  return (
    <>
      <Head>
        <title>Politica de privacidade | BoraTickets</title>
      </Head>
      <TemplatePoliticaPrivacidade />
    </>
  );
}
